import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchBatchProvisions = async (periodName, connection) => await fetch(
  Config.endpoints.BATCH_PROVISIONS_STATUS
    .replace(/:periodName/, periodName)
    .replace(/:connectionName/, connection)
)
  .then(handleErrors({ errorMessage: 'Fetching batch provisions failed' }))
  .then(parseAsJson);

export const uploadBatchProvisions = async data => await fetch(
  Config.endpoints.BATCH_PROVISIONS,
  {
    method: 'POST',
    body: JSON.stringify(data),
  }
)
  .then(handleErrors({ errorMessage: 'Batch Provisions upload failed' }))
  .then(parseAsJson);

export const processBatchProvisions = async data => await fetch(
  Config.endpoints.PROCESS_BATCH_PROVISIONS,
  {
    method: 'POST',
    body: JSON.stringify(data),
  }
)
  .then(handleErrors({ errorMessage: 'Batch Provisions processing initialization failed' }));

export const processBatchProvisionsSync = async data => await fetch(
  Config.endpoints.PROCESS_BATCH_PROVISIONS_SYNC,
  {
    method: 'POST',
    body: JSON.stringify(data),
  }
)
  .then(handleErrors({ errorMessage: 'Batch Provisions processing initialization failed' }));

export const processBatchProvisionsForGlUIConnection = async data => await fetch(
  Config.endpoints.PROCESS_BATCH_PROVISIONS_FOR_GL_UI_CONNECTION,
  {
    method: 'POST',
    body: JSON.stringify(data),
  }
)
  .then(handleErrors({ errorMessage: 'Batch Provisions processing integration failed' }))
  .then(parseAsJson);


export const processBatchProvisionsForFTPConnection = async ({ periodName, connName }) => await fetch(
  Config.endpoints.PROCESS_BATCH_PROVISIONS_FOR_FTP_CONNECTION
    .replace(/:periodName/, periodName)
    .replace(/:connName/, connName)
)
  .then(handleErrors({ errorMessage: 'Batch Provisions processing failed' }))
  .then(parseAsJson);


export const setProcessingBatchProvisionStatus = async data => await fetch(
  Config.endpoints.BATCH_PROVISIONS_SET_STATUS_PROCESSING,
  {
    method: 'POST',
    body: JSON.stringify(data),
  }
)
  .then(handleErrors({ errorMessage: 'Batch Provisions changing status failed' }))
  .then(parseAsJson);

export const fetchBatchProvisionsConnections = async periodName => await fetch(
  Config.endpoints.BATCH_PROVISIONS_CONNECTIONS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching batch provisions connections failed' }))
  .then(parseAsJson);
